import React from "react";

import OurProgrammePortfolioHeader from "../header/OurProgrammePortfolioHeader";

export const CompanyWithinPortfolioHeader = ({
                                                 company: {
                                                     settings: {portfolioName, portfolioCompanyName, currency, performancePeriod, periodStart, internal, generatedAt},
                                                     overallGrouping,
                                                     overallGroupSize
                                                 },
                                                 portfolioId,
                                                 selectedKpi,
                                                 periods,
                                                 ourProgrammeContext
                                             }) => {

    const kpiValue = overallGrouping ? selectedKpi.valueFor(overallGrouping) : null;
    const companyName = overallGrouping ? overallGrouping.groupName : "";
    const numberOfNewIdeas = overallGrouping && overallGrouping.numberOfNewIdeas ? overallGrouping.numberOfNewIdeas : 0;

    return (
        <OurProgrammePortfolioHeader performancePeriod={performancePeriod}
                                     periodStart={periodStart}
                                     portfolioName={portfolioName}
                                     portfolioId={portfolioId}
                                     companyName={companyName}
                                     showCompanyName={true}
                                     ownerName={internal ? "internal" : portfolioCompanyName}
                                     kpiName={selectedKpi.name}
                                     kpiValue={kpiValue}
                                     currency={currency}
                                     showCompanyRank={true}
                                     companyRank={overallGrouping && overallGrouping.rank}
                                     totalCompanies={overallGroupSize}
                                     numberOfNewIdeas={numberOfNewIdeas}
                                     periods={periods}
                                     ourProgrammeContext={ourProgrammeContext}
                                     generatedAt={generatedAt}
        />
    );
};
